// src/features/explore/panels/FeaturedCollectionsPanel.tsx
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import { useExplore } from '@/hooks';
import { PanelEmpty } from '@/components/panels/PanelEmpty';

const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px;`;
const Item = styled.li`display: flex; flex-direction: column; gap: 2px;`;
const Name = styled.span`
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600; color: ${({ theme }) => theme.color.textPrimary};
`;
const Count = styled.span`
  font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function FeaturedCollectionsPanel() {
  const { featuredCollections } = useExplore();
  return (
    <Panel>
      <SectionLabel as="h2">Featured Collections</SectionLabel>
      {featuredCollections.length === 0 ? (
        <PanelEmpty>No collections yet.</PanelEmpty>
      ) : (
        <List>
          {featuredCollections.map((c) => (
            <Item key={c.name}>
              <Name>{c.name}</Name>
              <Count>{c.count}</Count>
            </Item>
          ))}
        </List>
      )}
    </Panel>
  );
}
